import { HomePageContainer } from './HomePageContainer';

export { HomePage } from './HomePage';
export { CUSTOM_PAGE_QUERY } from './HomePage';

export default HomePageContainer;
